import React, { Fragment } from "react";
import TextField from "../../common/TextField";
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import SingleSelect from "../../common/SingleSelect";

const UserTypeSection = (props) => (
  <Fragment>
    {!props.editOption && (
      <>
        <Grid container spacing={2}>
          <Grid item md={3} sm={6} xs={12}>
            <TextField
              id="userType"
              select
              label={props.translate("userType")}
              value={props.form.userType || ""}
              onChange={props.handleChange("userType")}
              SelectProps={{
                MenuProps: {
                  className: props.classes.menu,
                },
              }}
              margin="dense"
              fullWidth
              error={Boolean(props.addUserFieldErrors?.userType)}
              required
            >
              <MenuItem value="">
                <em>{props.translate("none")}</em>
              </MenuItem>
              {props.userTypeArray.length &&
                props.userTypeArray.map((option) => (
                  <MenuItem key={option.key} value={option.key}>
                    {props.translate(option.name)}
                  </MenuItem>
                ))}
            </TextField>
          </Grid>
          {!props.editOption && props.form.userType > 2 && (
            <Grid item sm={6} md={3} xs={12} style={{ zIndex: 99 }}>
              <SingleSelect
                array={props.defaultCompaniesList || []}
                async
                selectName="companyId"
                isClearable
                label={
                  <p style={{ fontSize: "0.9rem" }}>
                    {props.translate("searchCompany")}
                  </p>
                }
                value={
                  props.companySelectedData && props.companySelectedData.id
                    ? {
                        id: props.companySelectedData.id,
                        value: props.companySelectedData.id,
                        label: props.companySelectedData.label,
                      }
                    : null
                }
                handleChange={props.timezone_handleChange}
                canAssign={true}
                menuPlacement="auto"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  control: (base, state) => ({
                    ...base,
                    ...(props.addUserFieldErrors?.companyId
                      ? {
                          borderColor: "red",
                        }
                      : {}),
                  }),
                }}
              />
            </Grid>
          )}
        </Grid>
      </>
    )}
  </Fragment>
);

export default UserTypeSection;
